import { inject, injectable } from 'inversify'
import { SERVICE_TYPES } from '@/core/container/types'
import type { PostHogService } from '@/services/tracking/postHogService'
import type GoogleAnalyticsService from '@/services/tracking/googleAnalyticsService'
import { GoogleAnalyticsEvent } from '@/services/tracking/types'
import type LocalStorageAdapter from '@/services/transport/storage/localStorageAdapter'
import type UserService from '@/services/domain/user/userService'

@injectable()
export default class SignUpTrackingService {
  protected signUpEvent: string = 'signUpEvent'

  constructor(
    @inject(SERVICE_TYPES.PostHogService) protected readonly postHogService: PostHogService,
    @inject(SERVICE_TYPES.GoogleAnalyticsService) protected readonly googleAnalyticsService: GoogleAnalyticsService,
    @inject(SERVICE_TYPES.LocalStorageAdapter) protected readonly localStorageAdapter: LocalStorageAdapter,
    @inject(SERVICE_TYPES.UserService) protected readonly userService: UserService,
  ) {}

  public trackSignUp(signUpType: string): void {
    const user = this.userService.getCurrentUserOrNull()

    if (user && !this.isSignUpTriggered(user.id)) {
      this.storeSignUpEvent(user.id)
      this.postHogService.trackSignUp(signUpType)
      this.googleAnalyticsService.trackConversion(GoogleAnalyticsEvent.signUp)
    }
  }

  protected storeSignUpEvent(userId: string): void {
    this.localStorageAdapter.setJSON(this.signUpEvent, { id: userId })
  }

  protected isSignUpTriggered(userId: string): boolean {
    const storedId: string | null = this.localStorageAdapter.getJSON(this.signUpEvent)?.id
      ? (this.localStorageAdapter.getJSON(this.signUpEvent).id as string)
      : null

    return storedId === userId
  }
}
